import { render, staticRenderFns } from "./RcWidgetPresRow.vue?vue&type=template&id=8f84215e&"
import script from "./RcWidgetPresRow.vue?vue&type=script&lang=js&"
export * from "./RcWidgetPresRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports